import { TILE_SIZE } from "@cold-case/shared/constants";

import { WORLD_HEIGHT, WORLD_WIDTH } from "./design-resolution.js";

/** Tile counts; must stay aligned with `LAYER_A_GRID_W` / `LAYER_A_GRID_H` in `@cold-case/shared`. */

export { TILE_SIZE };
export const TILES_W = Math.ceil(WORLD_WIDTH / TILE_SIZE);
export const TILES_H = Math.ceil(WORLD_HEIGHT / TILE_SIZE);
